import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { isTokenExpired } from "../services/api"; // Asegúrate de tener estas funciones en tu API

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();

  return !isAuthenticated || isTokenExpired() ? (
    <Navigate to="/login" />
  ) : (
    children
  );
};

export default ProtectedRoute;
